export async function addOrderCard(info) {
    const card = document.createElement('div');
    card.classList.add('user-card-default__item', 'accordion-item', 'accordion-item_header-click');

    const trackNumber = info.track_number.length > 0 ? info.track_number[0] : 'Отсутсвует';

    let continueBtn = '';
    if(info.status === 'created') {
        continueBtn = `
            <div class="user-card-default__item__continue-btn">
                <a href="/order/edit-order/?order_id=${info.id}"
                    class="button button_size_basic button_outline">
                    Продолжить оформление
                </a>
            </div>
        `;
    } else if(info.status === 'wait_payment') {
        continueBtn = `
            <div class="user-card-default__item__continue-btn">
                <a href="${info.payment_url}"
                    class="button button_size_basic button_outline">
                    Оплатить
                </a>
            </div>
        `;
    }
    
    card.innerHTML = `
        <div class="user-card-default__item__header accordion-item__header">
            <div class="user-card-default__item__header__title-block" data-status="${info.status}">
                ${info.status_display}
                <span>№${info.order_number}</span>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.26321 9.86409C6.43196 9.69555 6.66071 9.60088 6.89921 9.60088C7.13771 9.60088 7.36646 9.69555 7.53521 9.86409L11.9992 14.3281L16.4632 9.86409C16.5456 9.77566 16.645 9.70474 16.7554 9.65555C16.8658 9.60636 16.9849 9.57991 17.1058 9.57778C17.2266 9.57565 17.3467 9.59787 17.4587 9.64314C17.5708 9.68841 17.6726 9.75578 17.7581 9.84124C17.8435 9.9267 17.9109 10.0285 17.9562 10.1406C18.0014 10.2526 18.0237 10.3727 18.0215 10.4935C18.0194 10.6144 17.9929 10.7335 17.9437 10.8439C17.8946 10.9543 17.8236 11.0537 17.7352 11.1361L12.6352 16.2361C12.4665 16.4046 12.2377 16.4993 11.9992 16.4993C11.7607 16.4993 11.532 16.4046 11.3632 16.2361L6.26321 11.1361C6.09467 10.9673 6 10.7386 6 10.5001C6 10.2616 6.09467 10.0328 6.26321 9.86409Z" fill="#383838" fill-opacity="0.6"/>
            </svg>
        </div>
        <div class="accordion-item__body">
            <div class="user-card-default__item__body">
                <div class="user-card-default__item__body__info-block">
                    <div class="user-card-default__item__body__info-block__item">
                        <span>Дата заказа</span>
                        ${new Date(info.created_at).toLocaleDateString('ru-RU')}
                    </div>
                    <div class="user-card-default__item__body__info-block__item">
                        <span>Стоимость</span>
                        ${info.cost}  ₽
                    </div>
                    <div class="user-card-default__item__body__info-block__item">
                        <span>Трек-номер</span>
                        ${trackNumber}
                    </div>
                </div> 
                <div class="user-card-default__item__body__title">
                    Позиции в заказе
                </div>
            </div>
        </div>
        <div class="user-card-default__item__images custom-scrollbar_horizontal"></div>
        ${continueBtn}
    `;

    const imagesBlock = card.querySelector('.user-card-default__item__images');
    await createImages(info.items, imagesBlock);

    return card;
}

async function createImages(items, block) {
    const fragment = document.createDocumentFragment();
    const promises = items.map(async(item)=>{
        const card = document.createElement('div');
        card.classList.add('user-card-default__item__images__image');
        const image = item.main_photo ? item.main_photo : '/static/assets/images/stub.webp';
        card.innerHTML = `
            <img src="${image}" alt="product image">
        `;
        fragment.appendChild(card);
    });
    Promise.all(promises).then(()=>block.appendChild(fragment));
}